"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Overlay = void 0;
var react_1 = __importDefault(require("react"));
function Overlay(_a) {
    var _b = _a.opacity, opacity = _b === void 0 ? 0.6 : _b, _c = _a.color, color = _c === void 0 ? '#fff' : _c, _d = _a.zIndex, zIndex = _d === void 0 ? 1000 : _d, style = _a.style, _e = _a.component, Element = _e === void 0 ? 'div' : _e, others = __rest(_a, ["opacity", "color", "zIndex", "style", "component"]);
    return (react_1.default.createElement(Element, __assign({ style: __assign({ opacity: opacity, backgroundColor: color, position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, zIndex: zIndex }, style) }, others)));
}
exports.Overlay = Overlay;
Overlay.displayName = '@mantine/core/Overlay';
